export default function CTASection() {
  return (
    <section className="relative w-full min-h-[520px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20pastel%20beauty%20and%20fashion%20product%20display%20on%20soft%20cream%20backdrop%2C%20minimal%20lifestyle%20flat%20lay%20with%20cosmetics%20handbags%20and%20accessories%2C%20warm%20neutral%20color%20palette%2C%20soft%20natural%20window%20light%2C%20scandinavian%20interior%20style%2C%20editorial%20brand%20photography%2C%20airy%20and%20clean%20aesthetic%2C%20gentle%20warm%20tone%20gradient%20from%20left%20to%20right&width=1600&height=600&seq=cta-bg-yoybuy-02&orientation=landscape"
          alt="YOYBUY shopping experience"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/30 via-white/10 to-white/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 md:px-10 py-20 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
        <div className="flex flex-col gap-6 max-w-[480px]">
          <h2 className="text-4xl md:text-[60px] font-heading font-bold text-foreground-950 lowercase leading-none">
            yoybuy sheet — умный шоппинг
          </h2>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 h-[56px] px-8 rounded-full bg-white border border-foreground-200/60 text-foreground-800 text-base font-medium hover:bg-accent-50 hover:border-accent-300 transition-all duration-300 cursor-pointer whitespace-nowrap self-start"
          >
            YOYBUY Sheet
            <span className="w-5 h-5 rounded-full bg-accent-500 flex items-center justify-center group-hover:bg-accent-600 transition-colors">
              <i className="ri-arrow-right-line text-white text-xs"></i>
            </span>
          </a>
        </div>

        <div className="max-w-[360px]">
          <p className="text-lg md:text-xl text-foreground-800 font-light leading-relaxed">
            Быстрая доставка в Россию и страны СНГ. Поддержка русскоязычных пользователей 24/7. Самые низкие комиссии среди всех агентов.
          </p>
        </div>
      </div>
    </section>
  );
}